import React from 'react';
import { FiX } from 'react-icons/fi';

import Button from '../Button';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

import styles from './ConfirmationModal.module.scss';

interface ConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  message: string;
  loading?: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  loading,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <Button className={styles.closeButton} type="button" variant="text" onClick={onCancel}>
            <FiX />
          </Button>
        </div>
        <div className={styles.message}>{message}</div>
        <div className={styles.actions}>
          <Button variant="default" className={styles.cancelButton} onClick={onCancel}>
            Отменить
          </Button>
          <Button variant="outlined" className={styles.confirmButton} onClick={onConfirm} disabled={loading}>
            {loading ? <LoadingSpinner size="sm" /> : 'Удалить'}
          </Button>
        </div>
      </div>
    </div>
  );
};
